import { globalHalfEdgeInfo } from "./globalHalfEdgeInfo.js";
export function createHalfEdgeId() {
    const n = globalHalfEdgeInfo.counter++;
    return n.toString();
}
//# sourceMappingURL=createHalfEdgeId.js.map